import { React } from 'react'
import BurgerMenu from "./BurgerMenu"

const MenuWrap = (props) => {
    const Menu = BurgerMenu['slide'];

    return (
        <div className={`${props.className}`}>
            <Menu
                id="slide"
                pageWrapId={'page-wrap'}
                outerContainerId={'outer-container'}
                right={false}
            >
                {props.children}
            </Menu>
        </div>
    );
}

export default MenuWrap;